import * as React from 'react';

function isTouchDevice(): boolean {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (navigator as any).msMaxTouchPoints > 0
  );
}

export const onInputFocus = (
  event: React.FocusEvent<HTMLInputElement>
): void => {
  if (!isTouchDevice()) return;
  const { currentTarget } = event;
  currentTarget.scrollIntoView(false);
};
